// @flow
import React, { useCallback, useEffect, useRef, useState } from "react";

// @asseinfo/react-kanban components
import Board, { addColumn } from "@asseinfo/react-kanban";

import {
	Box,
	CircularProgress,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import AddCircleRounded from "@mui/icons-material/AddCircleRounded";

import DataTable from "../../../../components/Tables/DataTable";
import KanbanCard from "../../../../components/Cards/KanbanCard";
import IALoadingButton from "../../../../components/IAButtons/IALoadingButton";

import colors from "../../../../assets/theme/light/colors";

import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "react-html-parser";
import Mnemonic from "../../../../Mnemonics.json";

import { getFiltersObject } from "./filtersConfig";
import { enqueueSnackbar } from "notistack";

import useAuth from "../../../../hooks/useAuth";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import useMutationAuth from "../../../../hooks/useMutationAuth";
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import { GET_ALL_TASK_STATES } from "../../../../graphql/taskSate";
import {
	GET_TASK_BOARD_DATA,
	UPDATE_TASK_QUICK,
} from "../../../../graphql/task";
import { GET_STATUS_COLOR } from "../../../../graphql/taskStatus";
import {
	getOptionPriorityIcon,
	SubtaskIcon,
} from "../../../../components/Icon";

import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";
import { useParams } from "react-router-dom";

export function TaskBoard({
	defaultFilters,
	setDefaultFilters,
	fromTicket,
	fromSubtask,
	fromProjectTasks,
	handleSaveUserTableFilters,
	openSavedFilters,
	setOpenSavedFilters,
	selectedFilterGuid,
	handleCloseModal,
	parentGuid,
	refetch,
	refetchStatus,
	doing,
	fromTenant,
	fromBacklog,
	fromProject,
	setDoing,
	parentName,
	chipFilters,
	setChipFilters,
	//taskStatesList,
	statusLoading,
	//statusColorsList,
	employeesList,
	taskStateList,
	teams_list,
	projectsList,
	areaList,
	taskList,
	teamsLoading,
	projectLoading,
	employeeLoading,
	// statusLoading={statusLoading}
	areaLoading,
	taskLoading,
	employeeWait,
	//customButtons ,
	showAsBoard,
	setShowAsBoard,
}) {
	const {
		isEmployee,
		storeUserGuid,
		storeUserTenant,
		isManager,
		userRoles,
		storeUserTeams,
	} = useAuth();
	const { isAdmin, manageSystemConfigurations, manageTimeEntry } = userRoles;
	const { t } = useTranslation();
	const boardContainerRef = useRef(null);
	const count = useRef(0);
	const [search, setSearch] = useState("");
	const [filters, setFilters] = useState(null);
	const [loading, setLoading] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const { pID } = useParams();
	const [selectedProject, setSelectedProject] = useState([]);
	const addNewSubtask = useRef(false);
	const [fetchProjects, setFetchProjects] = useState(false);
	const [fetchTasks, setFetchTasks] = useState(false);
	const [fetchAreas, setFetchAreas] = useState(false);
	// const [fetchEmployees, setFetchEmployees] = useState(false);
	const [selectedTask, setSelectedTask] = useState(null);
	const [selectedTaskName, setSelectedTaskName] = useState("");
	const [newColumnFlag, setNewColumnFlag] = useState(false);
	const [filterState, setFilterState] = useState([]);
	const [rowGuid, setRowGuid] = useState("");
	const [projectID, setProjectID] = useState();
	const [projectName, setProjectName] = useState();
	const [type, setType] = useState(null);
	const [parent, setParent] = useState(null);
	const [showQuickFilters, setShowQuickFilters] = useState(() => {
		const savedState = localStorage.getItem("showQuickFilters");
		return savedState === "true";
	});
	const [data, setData] = useState({ columns: [] });
	const [taskStatesList, setTaskStatesList] = useState([]);
	const [fetchTaskStates, setFetchTaskStates] = useState(false);

	const [statusColorsList, setStatusColorsList] = useState([]);
	const [fetchTaskStatuses, setFetchTaskStatuses] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const prioritiesList = [
		{
			label: Mnemonic.Priority.Low,
			value: Mnemonic.Priority.Low,
		},
		{
			label: Mnemonic.Priority.Medium,
			value: Mnemonic.Priority.Medium,
		},
		{
			label: Mnemonic.Priority.High,
			value: Mnemonic.Priority.High,
		},
	];

	const handleOpenModal = (row) => {
		const rowID = Object.keys(rowGuid)[0];
		if (fromSubtask) {
			handleCloseModal();
		}
		setSelectedTask(fromSubtask && !row ? null : row?.task?.taskGuid);
		setSelectedProject(
			fromSubtask ? projectID : row?.task?.ticket?.project?.projectGuid
		);
		setSelectedTaskName(fromSubtask && !row ? null : row?.task?.title);
		setProjectName(
			fromSubtask
				? projectName
				: row?.task?.ticket?.project?.title
					? row?.task?.ticket?.project?.title
					: data?.map((x) => x.task).filter((x) => x.guid == rowID)[0]
								?.projectName
						? data?.map((x) => x.task).filter((x) => x.guid == rowID)[0]
								?.projectName
						: null
		);
		setType(fromSubtask ? "subtask" : "task");
		addNewSubtask.current = fromSubtask;
		setParent({
			taskGuid: parentGuid,
			title: parentName,
		});
		setTimeout(() => {
			setOpenModal(true);
		}, 500);
	};

	const findProjectDetails = (data, rowID) => {
		for (let item of data) {
			if (item?.task?.guid === rowID) {
				return {
					projectGuid: item.task.projectGuid,
					projectName: item.task.projectName,
					title: item.task.title,
				};
			}

			if (item.subtasks && item.subtasks.length > 0) {
				for (let subtask of item.subtasks) {
					if (subtask?.task?.guid === rowID) {
						return {
							projectGuid: subtask.task.projectGuid,
							projectName: subtask.task.projectName,
							title: subtask.task.title,
						};
					}

					// Recursive search in deeper subtasks
					const result = findProjectDetails(
						subtask?.subtasks || [],
						rowID
					);
					if (result) {
						return result;
					}
				}
			}
		}

		return null;
	};

	const handleAddNew = (type) => {
		if (type === "subtask") {
			setSelectedTask(null);
			setSelectedProject(null);
			setSelectedTaskName(null);
			setProjectName(null);
			setType(type);
			setParent(null);
			setTimeout(() => {
				setOpenModal(true);
			}, 500);
		} else {
			setSelectedTask(null);
			setSelectedProject(null);
			setSelectedTaskName(null);
			setProjectName(null);
			setType(type);
			setParent(null);
			setTimeout(() => {
				setOpenModal(true);
			}, 500);
		}
	};

	const {
		mfunction: getAllTasksList,
		loading: tasksListLoading,
		refetch: refetchTasks,
	} = useLazyQueryAuth(GET_TASK_BOARD_DATA, "GetTaskStatusesWithTasks");

	const customButtons = [
		{
			label: "table.list",
			disabled: tasksListLoading,
			condition: true,
			icon: true,
			iconButton: (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					width="24"
					height="24"
					stroke-width="2"
				>
					<path d="M9 6h11"></path>
					<path d="M12 12h8"></path>
					<path d="M15 18h5"></path>
					<path d="M5 6v.01"></path>
					<path d="M8 12v.01"></path>
					<path d="M11 18v.01"></path>
				</svg>
			),
			handleClick: () => {
				setShowAsBoard(false);
			},
		},
		{
			label: "dashboard.subtask.addNew",
			handleClick: () => {
				handleAddNew("subtask");
			},
			condition: isEmployee !== Mnemonic.ResourceTypes.External,
			icon: true,
			iconButton: <SubtaskIcon color={colors.light_logo_blue} />,
		},
		{
			label: "dashboard.task.addNew",
			handleClick: () => {
				handleAddNew("task");
			},
			condition:
				isEmployee !== Mnemonic.ResourceTypes.External &&
				manageTimeEntry === "M" &&
				!fromSubtask,
			icon: true,
			iconButton: (
				<AddCircleRoundedIcon
					sx={{
						color: colors.light_logo_blue,
						fontSize: "28px !important",
					}}
				/>
			),
		},
	];

	const handleChipClick = (newChipFilters) => {
		let updatedDefaultFilters = { ...defaultFilters };
		let updatedFilterState = [...filterState];

		if (newChipFilters.assignedToMe) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
				employeeIDs: [storeUserGuid],
			};

			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value = [storeUserGuid];
			} else {
				updatedFilterState.push({
					value: [storeUserGuid],
					property: "employeeIDs",
				});
			}

			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				updatedFilterState[teamIndex].value =
					updatedFilterState[teamIndex]?.value || [];
			} else {
				updatedFilterState.push({ value: null, property: "teamsIDs" });
			}
		} else {
			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value = updatedFilterState[
					employeeIndex
				].value?.filter((id) => id !== storeUserGuid);

				if (updatedFilterState[employeeIndex].value?.length === 0) {
					updatedFilterState.splice(employeeIndex, 1);
				}
			}

			// delete updatedDefaultFilters.employeeIDs;
		}

		if (newChipFilters.assignedToMyTeam) {
			const filteredTeams = storeUserTeams?.map((x) => x.team);
			const filteredTeamsGuids = filteredTeams.map((t) => t.teamGuid);

			updatedDefaultFilters = {
				...updatedDefaultFilters,
				teamsIDs: filteredTeamsGuids,
			};

			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				updatedFilterState[teamIndex].value = filteredTeamsGuids;
			} else {
				updatedFilterState.push({
					value: filteredTeamsGuids,
					property: "teamsIDs",
				});
			}

			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value =
					updatedFilterState[employeeIndex].value?.map(
						(x) => x?.employeeGuid
					) || [];
			} else {
				updatedFilterState.push({ value: null, property: "employeeIDs" });
			}
		} else {
			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				const existingTeamIDs = updatedFilterState[teamIndex].value || [];
				const filteredTeams = storeUserTeams?.map((x) => x.team);
				const filteredTeamsGuids = filteredTeams.map((t) => t.teamGuid);
				updatedFilterState[teamIndex].value = existingTeamIDs.filter(
					(id) => !filteredTeamsGuids.includes(id)
				);

				if (updatedFilterState[teamIndex].value?.length === 0) {
					updatedFilterState.splice(teamIndex, 1);
				}
			}
		}

		if (newChipFilters.myProjectTasks) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
			};
		}

		if (newChipFilters.highPriority) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
				priority: null,
			};

			const priorityIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "priority"
			);
			if (priorityIndex >= 0) {
				updatedFilterState[priorityIndex].value = null;
			} else {
				updatedFilterState.push({ value: null, property: "priority" });
			}
		}

		setDefaultFilters(updatedDefaultFilters);
		setFilterState(updatedFilterState);
		// setChipFiltersClicked(!chipFiltersClicked);
	};

	useEffect(() => {
		if (selectedFilterGuid === null) {
			setChipFilters({
				showParents: pID ? true : false,
				assignedToMe: false,
				assignedToMyTeam: false,
				onlySubtasks: true,
				onlyTasks: true,
				myProjectTasks: isAdmin ? false : !isAdmin && pID ? true : false,
				doing: false,
			});
		}
	}, [selectedFilterGuid]);
	const chips = [
		{
			label: t("ts.AssignedToMe"),
			tooltip: t("ts.assignedtometooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newAssignedToMe = !chipFilters.assignedToMe;
				const newChipFilters = {
					...chipFilters,
					assignedToMe: newAssignedToMe,
					myProjectTasks:
						chipFilters.assignedToMyTeam || newAssignedToMe
							? false
							: true,
				};
				setChipFilters(newChipFilters);
				handleChipClick(newChipFilters);
			},
			color: chipFilters.assignedToMe ? "primary" : "default",
			variant: chipFilters.assignedToMe ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.assignedToMe
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.AssignedToMyTeam"),
			tooltip: t("ts.assignedtomeyteamtooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newAssignedToMyTeam = !chipFilters.assignedToMyTeam;
				const newChipFilters = {
					...chipFilters,
					assignedToMyTeam: newAssignedToMyTeam,
					myProjectTasks:
						chipFilters.assignedToMe || newAssignedToMyTeam
							? false
							: true,
				};
				setChipFilters(newChipFilters);
				handleChipClick(newChipFilters);
			},
			color: chipFilters.assignedToMyTeam ? "primary" : "default",
			variant: chipFilters.assignedToMyTeam ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.assignedToMyTeam
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.OnlyTasks"),
			tooltip: t("ts.taskstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				setChipFilters((prevFilters) => {
					const newOnlyTasks = !prevFilters.onlyTasks;
					const newOnlySubtasks = prevFilters.onlySubtasks;

					if (!newOnlyTasks && !newOnlySubtasks) {
						return {
							...prevFilters,
							onlyTasks: false,
							onlySubtasks: true,
						};
					}

					return {
						...prevFilters,
						onlyTasks: newOnlyTasks,
					};
				});
			},
			color: chipFilters.onlyTasks ? "primary" : "default",
			variant: chipFilters.onlyTasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.onlyTasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.OnlySubtasks"),
			tooltip: t("ts.subtaskstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				setChipFilters((prevFilters) => {
					const newOnlySubtasks = !prevFilters.onlySubtasks;
					const newOnlyTasks = prevFilters.onlyTasks;

					if (!newOnlySubtasks && !newOnlyTasks) {
						return {
							...prevFilters,
							onlySubtasks: false,
							onlyTasks: true,
						};
					}

					return {
						...prevFilters,
						onlySubtasks: newOnlySubtasks,
					};
				});
			},
			color: chipFilters.onlySubtasks ? "primary" : "default",
			variant: chipFilters.onlySubtasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.onlySubtasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.myprojectTasks"),
			tooltip: t("ts.myprojectstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newMyProjectTasks = !chipFilters.myProjectTasks;
				const newChipFilters = {
					...chipFilters,
					myProjectTasks: newMyProjectTasks,
					assignedToMe: newMyProjectTasks
						? false
						: chipFilters.assignedToMe,
					assignedToMyTeam: newMyProjectTasks
						? false
						: chipFilters.assignedToMyTeam,
				};
				setChipFilters(newChipFilters);
				if (
					!newMyProjectTasks &&
					!chipFilters.assignedToMe &&
					!chipFilters.assignedToMyTeam &&
					!isAdmin
				) {
					newChipFilters.assignedToMe = true;
				}
				handleChipClick(newChipFilters);
			},
			color: chipFilters.myProjectTasks ? "primary" : "default",
			variant: chipFilters.myProjectTasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.myProjectTasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},

		{
			tooltip: t("ts.prioritytooltip"),
			icon: getOptionPriorityIcon("High", { marginRight: "-17px" }),
			visible: true,

			onClick: () => {
				count.current = count.current + 1;
				const newChipFilters = {
					...chipFilters,
					highPriority: true,
				};

				handleChipClick(newChipFilters);
				setDoing(!doing);
				setChipFilters((prevFilters) => ({
					...prevFilters,
					doing: !prevFilters.doing,
				}));
			},
			color: doing ? "primary" : "default",
			variant: doing ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: doing ? "white" : `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: openSavedFilters
				? t("ts.hideSavedFilters")
				: t("ts.showSavedFilters"),
			onClick: () => {
				setOpenSavedFilters((oldValue) => !oldValue);
			},
			variant: openSavedFilters ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: openSavedFilters
						? `${colors.icon_button_grey} !important`
						: `${colors.chip_label} !important`,
				},
			},
			visible: true,
		},
	];

	const {
		mfunction: getAlltaskStates,
		loading: taskStatesWait,
		refetch: refetchTaskStates,
	} = useLazyQueryAuth(GET_ALL_TASK_STATES, "GetAllTaskStates");
	useEffect(() => {
		if (newColumnFlag) {
			getAlltaskStates({}, (response) => {
				setTaskStatesList(
					response &&
						response.GetAllTaskStates &&
						response.GetAllTaskStates.tasksState
						? response.GetAllTaskStates.tasksState
						: []
				);
			});
		}
	}, [newColumnFlag]);

	const {
		mfunction: getAlltaskStatusColor,
		loading: taskStatusColorWait,
		refetch: refetchTaskStatusColor,
	} = useLazyQueryAuth(GET_STATUS_COLOR, "GetStatusColors");
	useEffect(() => {
		if (newColumnFlag) {
			getAlltaskStatusColor({}, (response) => {
				setStatusColorsList(
					response &&
						response.GetStatusColors &&
						response.GetStatusColors.statusColors
						? response.GetStatusColors.statusColors
						: []
				);
			});
		}
	}, [newColumnFlag]);

	const { cfunction: updateTaskQuickData } = useMutationAuth(
		UPDATE_TASK_QUICK,
		"UpdateTaskQuick"
	);

	const updateTaskQuick = (taskGuid, statusGuid) => {
		updateTaskQuickData(
			{
				variables: {
					model: {
						taskGuid: taskGuid,
						userID: storeUserGuid,
						statusGuid: statusGuid,
						key: uuidv4(),
					},
				},
			},
			(response) => {
				if (
					response["UpdateTaskQuick"].errorCode !== null &&
					response["UpdateTaskQuick"].errorCode !== ""
				) {
					enqueueSnackbar(t(response["UpdateTaskQuick"].errorMessage), {
						variant: "error",
						autoHideDuration: 5000,
					});
					refetchTasks();
				} else {
					enqueueSnackbar(t("board.savedSuccessfully"), {
						variant: "success",
					});
				}
			},
			(error) => {
				refetchTasks();
			}
		);
	};

	const fetchBoard = useCallback(
		(
			page = 0,
			pageSize = 20,
			order = "",
			orderBy = "",
			search = "",
			filters = null,
			chipFilters = null
		) => {
			getAllTasksList(
				{
					variables: {
						model: {
							tenantGuid: storeUserTenant,
							keyWord: search,
							filters: filters,
							userID: storeUserGuid,
							onlyTasks: chipFilters?.onlyTasks,
							onlySubtasks: chipFilters?.onlySubtasks,
							highPriority: chipFilters?.doing,
							myProjectsTasks: chipFilters?.myProjectTasks,
							projectGuid: fromTicket
								? pID
								: fromProjectTasks
									? pID
									: null,
							myTasks: chipFilters?.assignedToMe,
							myTeamsTasks: chipFilters?.assignedToMyTeam,
						},
					},
				},
				(response) => {
					const taskStatuses =
						response?.GetTaskStatusesWithTasks?.tasksStatusesWithTasksList
							?.taskStatuses || [];
					let columns = [];

					taskStatuses.forEach((taskStatus) => {
						const { taskStatusGuid, description, statusColor, tasks } =
							taskStatus;
						let tasksArr = [];
						console.log("tasks", tasks);

						tasks.forEach((task) => {
							const {
								guid,
								id,
								title,
								ticket,
								actualTime,
								estimatedEndDate,
								parentTaskGuid,
								priority,
								assignedTo,
							} = task;
							let taskObj = {
								id: guid,
								template: (
									<KanbanCard
										task={title}
										taskId={id}
										taskGuid={guid}
										type={parentTaskGuid ? "subtask" : "task"}
										project={ticket?.project?.title}
										dueDate={estimatedEndDate}
										priority={priority}
										actualTime={actualTime}
										assignedTo={assignedTo}
										updateTaskQuick={updateTaskQuick}
										storeUserGuid={storeUserGuid}
										refetch={refetchTasks}
									/>
								),
							};
							tasksArr.push(taskObj);
						});

						let statusObj = {
							id: taskStatusGuid,
							title: description,
							color: statusColor?.colorCode,
							cards: tasksArr,
						};
						columns.push(statusObj);
					});

					setData({ columns: columns });
					//  refetch()
				}
			);
		},
		[]
	);

	useEffect(() => {
		if (
			!statusLoading &&
			!employeeLoading &&
			!projectLoading &&
			!teamsLoading
		) {
			fetchBoard(0, 20, "", "", search, defaultFilters, chipFilters);
		}
	}, [
		chipFilters,
		defaultFilters,
		employeeLoading,
		statusLoading,
		projectLoading,
		teamsLoading,
	]);

	const filtersObject = getFiltersObject(
		(fromProject = !fromBacklog),
		projectsList,
		employeesList,
		taskStateList,
		teams_list,
		teamsLoading,
		projectLoading,
		employeeLoading,
		statusLoading,
		isAdmin,
		isManager,
		defaultFilters,
		filterState,
		areaList,
		areaLoading,
		taskList,
		taskLoading,
		setFetchProjects,
		setFetchTasks,
		setFetchAreas,
		setSelectedProject,
		selectedProject,
		prioritiesList
	);

	const tablePagination = {
		defaultFilters,
		setDefaultFilters,
		loading: tasksListLoading,
		search,
		customButtons,
		readOnly: isEmployee === Mnemonic.ResourceTypes.External,
		setSearch,
		handleRefresh: refetchTasks,
		disableAddBtn: true,
		searchText: fromTenant
			? "task.list.search.label.fromTenant"
			: "task.list.search.label",
		refetch: refetchTasks,
		filtersObject,
		treeTable: true,
		handleOpenModal,
		hideEditColumns: true,
		fetchTableData: fetchBoard,
	};
	useEffect(() => {
		let dynamicHeight = "calc(100vh - 190px)";
		let dynamicChildColumn = "calc(100vh - 260px)";

		if (pID) {
			if (showQuickFilters) {
				dynamicHeight = "calc(100vh - 330px)";
				dynamicChildColumn = "calc(100vh - 378px)";
			} else {
				dynamicHeight = "calc(100vh - 263px)";
				dynamicChildColumn = "calc(100vh - 310px)";
			}
		} else {
			if (showQuickFilters) {
				dynamicHeight = "calc(100vh - 250px)";
				dynamicChildColumn = "calc(100vh - 300px)";
			} else {
				dynamicHeight = "calc(100vh - 190px)";
				dynamicChildColumn = "calc(100vh - 240px)";
			}
		}

		document.documentElement.style.setProperty(
			"--dynamic-height",
			dynamicHeight
		);
		document.documentElement.style.setProperty(
			"--dynamic-child-column",
			dynamicChildColumn
		);
	}, [showQuickFilters, pID]);

	useEffect(() => {
		if (!isSubmitting && !statusLoading && !employeeLoading) {
			fetchBoard(0, 20, "", "", search, defaultFilters, chipFilters);
		}
	}, [chipFilters, isSubmitting]);

	const handleCardClick = (cardId, cardTitle) => {
		setSelectedTask(cardId);
		setSelectedTaskName(cardTitle);
		setOpenModal(true);
	};
	// Add this useEffect hook to improve scrolling during drag
	useEffect(() => {
		const container = boardContainerRef.current;
		if (!container) return;

		const THRESHOLD = 100; // px from edge before scrolling kicks in
		const SCROLL_SPEED = 20; // Increased scroll speed
		const SCROLL_INTERVAL = 50; // ms between scroll steps

		let scrollInterval = null;

		const handleDragOver = (e) => {
			e.preventDefault();
			const { left, right, width } = container.getBoundingClientRect();
			const scrollWidth = container.scrollWidth;
			const scrollLeft = container.scrollLeft;
			const clientX = e.clientX;

			// Clear any existing interval
			if (scrollInterval) {
				clearInterval(scrollInterval);
				scrollInterval = null;
			}

			// Check if we need to scroll right
			if (clientX > right - THRESHOLD && scrollLeft < scrollWidth - width) {
				scrollInterval = setInterval(() => {
					container.scrollLeft += SCROLL_SPEED;
				}, SCROLL_INTERVAL);
			}
			// Check if we need to scroll left
			else if (clientX < left + THRESHOLD && scrollLeft > 0) {
				scrollInterval = setInterval(() => {
					container.scrollLeft -= SCROLL_SPEED;
				}, SCROLL_INTERVAL);
			}
		};

		const handleDragEnd = () => {
			if (scrollInterval) {
				clearInterval(scrollInterval);
				scrollInterval = null;
			}
		};

		container.addEventListener("dragover", handleDragOver);
		container.addEventListener("dragend", handleDragEnd);
		container.addEventListener("drop", handleDragEnd);

		return () => {
			container.removeEventListener("dragover", handleDragOver);
			container.removeEventListener("dragend", handleDragEnd);
			container.removeEventListener("drop", handleDragEnd);
			if (scrollInterval) {
				clearInterval(scrollInterval);
			}
		};
	}, []);
	return (
		<div>
			<>
				<DataTable
					defaultChipFilters={{
						showParents: pID ? true : false,
						assignedToMe: pID ? false : true,
						assignedToMyTeam: pID ? false : true,
						onlySubtasks: true,
						onlyTasks: true,
						myProjectTasks: pID ? true : false,
						doing: false,
					}}
					handleResetChipFilter={() =>
						setChipFilters({
							showParents: pID ? true : false,
							assignedToMe: false,
							assignedToMyTeam: false,
							onlySubtasks: true,
							onlyTasks: true,
							myProjectTasks: isAdmin
								? false
								: !isAdmin && pID
									? true
									: false,
							doing: false,
						})
					}
					handleDefaultFilters={(f) => setFilters(f)}
					quickFilters
					savedFilterFlag={true}
					showUpdateFilterButton={
						selectedFilterGuid !== null &&
						selectedFilterGuid !== undefined &&
						selectedFilterGuid !== ""
					}
					handleUpdateFilter={handleSaveUserTableFilters}
					handleSaveFilter={handleSaveUserTableFilters}
					chips={chips}
					chipFilters={chipFilters}
					handleShowQuickFilters={(t) => setShowQuickFilters(t)}
					{...tablePagination}
				/>
				{tasksListLoading ? (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							margin: "40px",
						}}
					>
						<CircularProgress />
					</Box>
				) : (
					<Box ref={boardContainerRef} className="board-scroll-container">
						<Board
							key={JSON.stringify(data)}
							initialBoard={data}
							allowAddCard
							allowAddColumn
							disableColumnDrag
							onCardNew={console.log}
							renderColumnHeader={({ id, title, color }) => {
								const status = data.columns.find(
									(column) => column.id === id
								);
								const taskCount = status ? status.cards.length : 0;
								return (
									<>
										<Box
											display="flex"
											justifyContent="space-between"
											alignItems="center"
											mb={0}
											sx={{
												borderTop: `5px solid ${color}`,
												borderTopLeftRadius: "5px",
												borderTopRightRadius: "5px",
												backgroundColor: "#F0F0F0",
												position: "sticky",
											}}
										>
											<Typography
												ml={1.875}
												style={{
													textTransform: "uppercase",
													fontWeight: "bold",
													paddingBottom: "10px",
													fontSize: "12px",
													paddingTop: "10px",
													flexGrow: 1,
													marginRight: "8px",
												}}
											>
												{title}
												<span
													style={{
														fontWeight: "400",
														marginLeft: "8px",
													}}
												>
													{taskCount}
												</span>
											</Typography>
										</Box>
									</>
								);
							}}
							renderCard={({ id, template, task }, { dragging }) => {
								return (
									<Box
										key={id}
										className="board-box"
										onClick={() =>
											handleCardClick(
												id,
												task?.title || "Unknown Task"
											)
										}
										dragging={dragging}
										display="block"
										bgColor={"white"}
										color="text"
										borderRadius="xl"
										pt={2.5}
										py={0}
										pl={0}
										mr={0}
										ml={0}
										lineHeight={1.5}
										sx={{
											backgroundColor: "burlywood",
											fontSize: "15px",
											borderRadius: "5px",
										}}
									>
										{typeof template === "string"
											? ReactHtmlParser(template)
											: template}
									</Box>
								);
							}}
							onCardDragEnd={(board, card, source, destination) => {
								updateTaskQuick(card?.id, destination?.toColumnId);
								setData((prevData) => {
									const updatedColumns = prevData.columns.map(
										(column) => {
											if (column.id === source.fromColumnId) {
												return {
													...column,
													cards: column.cards.filter(
														(c) => c.id !== card.id
													),
												};
											}
											if (column.id === destination.toColumnId) {
												return {
													...column,
													cards: [...column.cards, card],
												};
											}
											return column;
										}
									);
									return { ...prevData, columns: updatedColumns };
								});
							}}
						/>
					</Box>
				)}
			</>

			<TaskTabsModal
				showModal={openModal}
				setShowModal={(v) => setOpenModal(v)}
				loading={loading || statusLoading}
				taskID={selectedTask}
				taskName={selectedTaskName}
				handleChangeTask={(v) => setSelectedTask(v)}
				handleChangeProject={(v) => setSelectedProject(v)}
				projectID={selectedProject}
				fromProject={true}
				refetch={() => {
					fetchBoard(0, 20, "", "", search, defaultFilters, chipFilters);
				}}
				open={JSON.parse(sessionStorage.getItem("unsavedChanges"))}
				modifyFormFlag={() =>
					sessionStorage.setItem("unsavedChanges", JSON.stringify(false))
				}
				type={type}
				setType={(v) => setType(v)}
				parent={parent}
				taskStatusList={taskStateList}
				data={data}
				updateData={(v) => setData(v)}
				totalFilters={chipFilters}
				// addNewSubtask={addNewSubtask.current}
				editMode={!addNewSubtask.current}
			/>
		</div>
	);
}
